import axios from "axios";
import moment from 'moment';

export default {
    state:{
        itemsserie:[]
    },
    mutations:{
        setSeries(state,series){
            state.itemsserie=series
        }
    },
    actions:{
        setSeries({commit,rootState},IdEstablecimiento){            
            axios.get(`${rootState.urlapi}/series/${IdEstablecimiento}`,{headers:{'auth-user':rootState.Usuario.token}})
            .then(response=>{  
                if(response.data.length>0){

                    commit("setSeries",response.data)
                    response.data.splice(response.data.length,1,{"IdResolucion":0,"Serie":"FEL",Vencimiento:moment().add(1, 'years')}) 
                }else{
                    commit("setSeries",[{"IdResolucion":0,"Serie":"FEL",Vencimiento:moment().add(1, 'years')}])
                }                         
            })
        }
    },
    getters:{
        getSeries(state){
            return state.itemsserie
        }
    }
}
